import makeStyles from '@mui/styles/makeStyles';

// Shared cover styling
export const useCoverStyles = makeStyles(() => ({
  root: {
    backgroundPosition: '50%',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
  },
}));
